// deps
import { useContext } from "react";

// internal-deps
import { RouteContext, RouteContextValue } from "@swiggy-private/core-ui";
import { CheckoutRoute, DineoutCheckoutRoute } from "@swiggy-private/checkout-types";

export const useNavigate = (): RouteContextValue<CheckoutRoute | DineoutCheckoutRoute>["navigateTo"] => {
    return useContext(RouteContext).navigateTo;
};
